import { Alert } from "react-bootstrap";

export default function NotResult(props) {
    return (
        <Alert variant="danger" id={props.id} className={props.className}>
            {props.title}
        </Alert>
    );
}
